// @type
import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

import { getRouteTFunction } from '../i18n';
import AlertBanner from './shared/AlertBanner.js';
import Text from './shared/Typography';
import Icon from './shared/Icon';

type Props = {
  shared_at: string,
  user: string,
  plural: boolean,
  token: string
}

const SharedResourceBanner = (props: Props) => {
  const { t } = useTranslation('sharedResourceBanner');
  const routesTFunction = getRouteTFunction();

  return (
    <div className='record-share__alert'>
      <AlertBanner type='alert'>
        {props.token &&
          <Link
            style={{
              marginRight: 20,
              marginTop: -3,
              backgroundColor: '#672BC2',
              borderRadius: 16,
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 8,
              paddingBottom: 8,
              marginBottom: 18,
              color: 'white',
              alignSelf: 'end'
            }}
            className='is-link'
            to={{ pathname: routesTFunction('redirectPaths./shared/:token/dashboard', { token: props.token }) }}
          >
              {t('back_to_dash')}
            </Link>
        }
        <Icon name='eye-open' size='medium' />
        <Text paragraph>
          <Trans
            i18nKey='viewing'
            t={t}
            values={{
              resource: props.plural ? t('resources') : t('resource'),
              user: props.user,
              date: moment(props.shared_at).format('ll')
            }}
            components={{
              bold: <strong />,
              span: <span />
            }}
          />
        </Text>
      </AlertBanner>
    </div>
  );
};

export default SharedResourceBanner;



// WEBPACK FOOTER //
// ./src/components/shared-resource-banner.js